import React from 'react';

const chitData = [
  { month: 1, contribution: 16500, halfShare: 8250, },
  { month: 2, contribution: 16420, halfShare: 8210, fullChit: 21000, halfChit: 10500 },
  { month: 3, contribution: 16250, halfShare: 8125, fullChit: 21000, halfChit: 10500 },
  { month: 4, contribution: 16170, halfShare: 8085, fullChit: 21000, halfChit: 10500 },
  { month: 5, contribution: 16000, halfShare: 8000, fullChit: 21000, halfChit: 10500 },
  { month: 6, contribution: 15750, halfShare: 7875, fullChit: 21000, halfChit: 10500 },
  { month: 7, contribution: 15500, halfShare: 7750, fullChit: 21000, halfChit: 10500 },
  { month: 8, contribution: 15340, halfShare: 7670, fullChit: 21000, halfChit: 10500 },
  { month: 9, contribution: 15090, halfShare: 7545, fullChit: 21000, halfChit: 10500 },
  { month: 10, contribution: 14920, halfShare: 7460, fullChit: 21000, halfChit: 10500 },
  { month: 11, contribution: 14750, halfShare: 7375, fullChit: 21000, halfChit: 10500 },
  { month: 12, contribution: 14420, halfShare: 7210, fullChit: 21000, halfChit: 10500 },
  { month: 13, contribution: 14170, halfShare: 7085, fullChit: 21000, halfChit: 10500 },
  { month: 14, contribution: 13750, halfShare: 6875, fullChit: 21000, halfChit: 10500 },
  { month: 15, contribution: 13420, halfShare: 6710, fullChit: 21000, halfChit: 10500 },
  { month: 16, contribution: 13000, halfShare: 6500, fullChit: 21000, halfChit: 10500 },
  { month: 17, contribution: 12500, halfShare: 6250, fullChit: 21000, halfChit: 10500 },
  { month: 18, contribution: 12000, halfShare: 6000, fullChit: 21000, halfChit: 10500 },
  { month: 19, contribution: 11500, halfShare: 5750, fullChit: 21000, halfChit: 10500 },
  { month: 20, contribution: 11000, halfShare: 6500, fullChit: 21000, halfChit: 10500 },
  { month: 21, contribution: 10500, halfShare: 5250, fullChit: 21000, halfChit: 10500 },
  { month: 22, contribution: 9500, halfShare: 4750, fullChit: 21000, halfChit: 10500 },
  { month: 23, contribution: 8750, halfShare: 4375, fullChit: 21000, halfChit: 10500 },
  { month: 24, contribution: 7750, halfShare: 3875, fullChit: 21000, halfChit: 10500 },
  { month: 25, contribution: 6750, halfShare: 3375, fullChit: 21000, halfChit: 10500 },
  { month: 26, contribution: 5750, halfShare: 2875, fullChit: 21000, halfChit: 10500 },
  { month: 27, contribution: 4750, halfShare: 2375, fullChit: 21000, halfChit: 10500 },
  { month: 28, contribution: 3750, halfShare: 1875, fullChit: 21000, halfChit: 10500 },
  { month: 29, contribution: 2920, halfShare: 1460, fullChit: 21000, halfChit: 10500 },
  { month: 30, contribution: 1670, halfShare: 835, fullChit: 21000, halfChit: 10500 },
  { month: 31, contribution: 840, halfShare: 420, fullChit: 21000, halfChit: 10500 }
];

const totals = {
  contribution: 351380,
  halfShare: 176690,
  fullChit: 630000,
  halfChit: 325500
};

const FiveLakhChitPlanTable = () => {
  return (
    <div className="bg-gray-100 min-h-screen py-10 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-7xl mx-auto bg-white shadow-xl rounded-2xl overflow-hidden">
        {/* Header Section */}
        <div className="p-8 sm:p-12 text-center bg-green-600 text-white">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-2 leading-tight">
            5 Lakh Chit Plan
          </h1>
          <p className="text-lg sm:text-xl opacity-90">
            Invest in Your Future with a Secure Chit Scheme
          </p>
        </div>

        {/* Call to Action and Summary */}
        <div className="p-8 sm:p-12 text-center bg-gray-50 border-b border-gray-200">
          <p className="text-gray-700 text-base sm:text-lg mb-6 max-w-2xl mx-auto">
            Our 31-month plan is designed to help you save systematically and earn
            returns. Find all the details below.
          </p>
          <a
            href="#"
            className="inline-block bg-green-600 text-white font-bold py-3 px-8 rounded-full shadow-lg hover:bg-green-700 transition duration-300 transform hover:scale-105"
            onClick={(e) => { e.preventDefault(); alert('Redirecting to the application page...'); }}
          >
            Join Now!
          </a>
        </div>

        {/* Table Section */}
        <div className="p-4 sm:p-8 overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200 rounded-lg overflow-hidden border border-gray-200">
            <thead className="bg-green-50">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-4 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider"
                  rowSpan="2"
                >
                  Month
                </th>
                <th
                  scope="col"
                  className="px-6 py-4 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider"
                  colSpan="2"
                >
                  Before Winning the Bid
                </th>
                <th
                  scope="col"
                  className="px-6 py-4 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider"
                  colSpan="2"
                >
                  After Winning the Bid
                </th>
              </tr>
              <tr className="bg-green-100">
                <th
                  scope="col"
                  className="px-6 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Contribution
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Half Share
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Full Chit
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Half Chit
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {chitData.map((row, index) => (
                <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800 text-center">{row.month}</td>
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800 text-center">{row.contribution}</td>
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800 text-center">{row.halfShare}</td>
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800 text-center">{row.fullChit}</td>
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800 text-center">{row.halfChit}</td>
                </tr>
              ))}
              {/* Totals Row */}
              <tr className="bg-green-200 font-bold">
                <td className="px-6 py-3 text-sm text-gray-800 text-center">Total</td>
                <td className="px-6 py-3 text-sm text-gray-800 text-center">{totals.contribution}</td>
                <td className="px-6 py-3 text-sm text-gray-800 text-center">{totals.halfShare}</td>
                <td className="px-6 py-3 text-sm text-gray-800 text-center">{totals.fullChit}</td>
                <td className="px-6 py-3 text-sm text-gray-800 text-center">{totals.halfChit}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Footer Section */}
        <div className="p-8 sm:p-12 text-center text-gray-500 text-xs bg-gray-100">
          <p>&copy; 2025 Chit Plans Inc. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default FiveLakhChitPlanTable;